module.exports = __webpack_public_path__ + "static/media/music.830f1fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/music.png
// module id = 1188
// module chunks = 110